import { HelpCenterProvider } from '@/HelpCenter/ui/context'
import { createHelpCenterRepository } from '@/HelpCenter/infrastructure/ApiHelpCenterRepository'
import { NewTicketFormContainer } from '@/HelpCenter/ui/organisms'


export const NewTicketPage = (): JSX.Element => {
    return (
        <HelpCenterProvider repository={createHelpCenterRepository()}>
            <div className="page-wrapper" style={{ paddingTop: '12px', display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <NewTicketFormContainer />
            </div>
        </HelpCenterProvider>
    )
}
